<template>
    <Button v-if="price" size="small" :disabled="!isAvailable || !webshopSettings().hasDispatchTypes" class="shrink-0  transition-transform" :class="{ 'sm:group-hover:scale-110': isAvailable && webshopSettings().hasDispatchTypes }">
        <span v-if="!isAvailable">{{ productMaximumReached ? $t('cart.limitations.maxReached') : $t('shopPage.product.soldOut') }}</span>
        <span v-else>
            <span v-if="shouldShowLabel" class="text-sm lowercase">{{ $t('shopPage.product.startingPrice') }}</span>
            {{ currencyFormat(totalPriceWithObligtedExtraItems) }}
        </span>
    </Button>
</template>

<script setup lang="ts">
    import type { PriceButtonProps } from '~/types/local-types'
    import { currencyFormat } from '@/utils/currency-utils'
    import Button from '~/components/Button.vue'
    import { webshopSettings } from '~/store/webshopSettings'
    const props = defineProps<PriceButtonProps>()
    const totalPriceWithObligtedExtraItems: number = Object.keys(props?.extras).length
        ? props?.extras?.flatMap(({ items, isVisible }) => {
            return items?.map(item => {
                return {
                    parentIsVisible: isVisible,
                    ...item
                }
            })
        }).reduce((total: number, item: any) => {
            if ((item.isSelected && item.isDisabled) || (!item.parentIsVisible && item.isSelected)) {
                return total + item.price
            }
            return total
        }, props?.price || 0)
        : props.price || 0

    const totalItemsInsideExtras = props?.extras?.flatMap(({ items }) => items).length
    const totalObligatedItems = props?.extras?.flatMap(({ items, isVisible }) => {
        return items?.map(item => {
            return {
                parentIsVisible: isVisible,
                ...item
            }
        })
    })?.filter((item: any) => (item.isSelected && item.isDisabled) || (!item.parentIsVisible && item.isSelected)).length
    const shouldShowLabel = (totalObligatedItems > 0 && totalObligatedItems < totalItemsInsideExtras) && totalPriceWithObligtedExtraItems > props.price
</script>
